import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cpSubmitFeedback } from "../../redux/actions/candidate-portal-actions";
import { Card, PageHeader, Pill, useCandidateId } from "./_shared";

const InterviewDetails = () => {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const candidateId = useCandidateId();
  const [submitted, setSubmitted] = useState(false);
  const [ratings, setRatings] = useState({ ratingOverall: 0, ratingClarity: 0, ratingDifficulty: 0, ratingExperience: 0 });
  const [text, setText] = useState("");
  const [recommend, setRecommend] = useState(null);

  const submit = async () => {
    await dispatch(cpSubmitFeedback({
      candidateId, interviewId: 13, jobId,
      ...ratings, feedbackText: text, wouldRecommend: recommend,
    }));
    setSubmitted(true);
  };

  return (
    <div>
      <PageHeader
        title="Interview Details"
        subtitle={`Job #${jobId}`}
        action={<Link to="/candidate/interviews" style={{ fontSize: 12, color: "#7B5AC4" }}>← Back to interviews</Link>}
      />
      <Card style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#0F172A" }}>Senior React Developer</div>
            <div style={{ fontSize: 12, color: "#64748B" }}>Ample Hire Inc · 5 questions · async video format</div>
          </div>
          <Pill color="#047857" bg="#D1FAE5">COMPLETED</Pill>
        </div>
        <div style={{ marginTop: 12, padding: 12, background: "#F8FAFC", borderRadius: 8, fontSize: 12, color: "#475569" }}>
          Your responses are being reviewed. Final score and detailed feedback will be available within 48 hours.
        </div>
      </Card>

      <Card>
        <h3 style={{ margin: "0 0 8px", fontSize: 14, fontWeight: 700, color: "#0F172A" }}>How was your experience?</h3>
        {submitted ? (
          <div style={{ padding: 16, background: "#ECFDF5", borderRadius: 8, color: "#047857", fontSize: 13 }}>
            Thanks for your feedback — it helps us improve the experience.
          </div>
        ) : (
          <>
            {[
              ["Overall", "ratingOverall"],
              ["Question clarity", "ratingClarity"],
              ["Difficulty", "ratingDifficulty"],
              ["Experience", "ratingExperience"],
            ].map(([lbl, key]) => (
              <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 13, color: "#475569" }}>{lbl}</span>
                <div style={{ display: "flex", gap: 4 }}>
                  {[1,2,3,4,5].map((n) => (
                    <button key={n} onClick={() => setRatings(r => ({ ...r, [key]: n }))}
                      style={{
                        width: 30, height: 30, borderRadius: 6,
                        border: ratings[key] === n ? "2px solid #7B5AC4" : "1px solid #E2E8F0",
                        background: ratings[key] === n ? "#EEF2FF" : "white",
                        color: ratings[key] === n ? "#4338CA" : "#64748B", fontWeight: 600, cursor: "pointer",
                      }}>
                      {n}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Anything you'd like to share..."
              style={{ width: "100%", padding: 10, border: "1px solid #E2E8F0", borderRadius: 6, fontSize: 12, marginBottom: 8, fontFamily: "inherit" }} />
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <button onClick={() => setRecommend(true)} style={{ flex: 1, padding: 8, borderRadius: 6, background: recommend === true ? "#ECFDF5" : "white", color: recommend === true ? "#047857" : "#64748B", border: recommend === true ? "2px solid #10B981" : "1px solid #E2E8F0", fontSize: 12, cursor: "pointer" }}>Would recommend</button>
              <button onClick={() => setRecommend(false)} style={{ flex: 1, padding: 8, borderRadius: 6, background: recommend === false ? "#FEF2F2" : "white", color: recommend === false ? "#991B1B" : "#64748B", border: recommend === false ? "2px solid #EF4444" : "1px solid #E2E8F0", fontSize: 12, cursor: "pointer" }}>Would not</button>
            </div>
            <button onClick={submit} disabled={Object.values(ratings).some(v => !v)} style={{ width: "100%", padding: 10, borderRadius: 6, background: "#7B5AC4", color: "white", border: "none", fontWeight: 600, cursor: "pointer" }}>
              Submit feedback
            </button>
          </>
        )}
      </Card>
    </div>
  );
};

export default InterviewDetails;
